/* @flow */

module.exports = {
  "LOCALE": {
    "ISO": {
      "639-1": "nb",
      "3166-1": "NO",
      "IETF": "nb-NO",
    },
    "CURRENCY": "NOK",
    "CURRENCY_SHORT": "kr",
    "TYPEKIT_ID": "thm8nca",
    "POINTS": "",
  },
  "SKIP_TO_CONTENT": "Gå til innhold",
  "CLOSE": "Lukke",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "LOGO": {
    "ALT": "Zupergift.com",
    "TITLE": "Hjem",
  },
  "COOKIE_CONSENT": {
    "TEXT": "Zupergift bruker cookies for å forbedre og tilpasse din opplevelse av våre digitale tjenester, Ved å fortsette å bruke dette nettstedet, aksepterer du bruken av cookies. Les vår <a href=\"/no/faq\">Personvernspolicy</a> dersom du vil vite mer eller deaktivere informasjonskapslene.",
    "ALL": "Tillat alle",
    "SELECTED": "Tillat valg",
    "NECESSARY": "Tillat nødvendige",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "ROUTES": {
    "ALL_GIFTCARDS": "/alle-gavekort",
  },
  "HOMEVIEW": {
    "HERO_ALT": "Zupergift.com",
    "REDEEM_CTA": "Bruk ditt Zupergift",
    "EXPLORE_CTA": " Utforske gavekortene",
    "EXPLORE_LINK": "/alle-gavekort",
    "ZUPERGIFT_CTA": "Kjøp Zupergift",
    "ZUPERGIFT_LINK": "/zupergift",
    "POPULAR_BRANDS": "Populære varemerker ",
    "POPULAR_CATEGORIES": "Populære kategorier",
    "POPULAR_PRODUCTS": "Populære gavekort",
    "SEE_MORE": "Se flere",
    "ALL_CATEGORIES": "Alle kategorier",
    "MORE_POPULAR_PRODUCTS": "Flere populære produkter",
    "BECOME_CUSTOMER": "Bli kunde",
    "TUTORIAL": "Det er slik det fungerer",
  },
  "TUTORIAL": {
    "STEP_1": {
      "TITLE": "1",
      "LINK_END": "her",
      "TEXT": "Kjøp Zupergift",
      "LINK": "/zupergift",
    },
    "STEP_2": {
      "TITLE": "2",
      "TEXT": "Levering direkte på e-post",
    },
    "STEP_3": {
      "TITLE": "3",
      "LINK_END": "her",
      "TEXT": "Løs i Zupergift",
      "LINK": "/redeem",
    },
    "STEP_4": {
      "TITLE": "4",
      "LINK_END": "her",
      "TEXT": "Velg gavekort",
      "LINK": "/alle-gavekort",
    },
  },
  "LOGIN": {
    "TITLE": "Logg inn som kunde",
    "EMAIL": "Din e-postadresse",
    "CUSTOMER_NUMBER": "Kundenummer du vill logge inn med",
    "PASSWORD": "Passord",
  },
  "REDEEM": {
    "HEADING": "Bruk ditt gavekort",
    "CLOSE": "Lukk",
    "TEXT": "Begynn med å oppgi din kode nedenfor, Koden finner du i meiljen som levererte ditt Zupergift-gavekort. I neste trinn velger du varemerker du ønsker å veksle gavekortet mot. Gå deretter til kassen og avlutt bestillingen, dine gavekort leveres til din e-post. Zuper-enkelt!",
    "PLACEHOLDER_CODE": "Oppgi kode",
    "PLACEHOLDER_PIN": "Oppgi pin",
    "SUBMIT": "Spare",
    "SUCCESS_ROUTE": "/alle-gavekort",
  },
  "ACCOUNT": {
    "LOGIN": "Logge inn",
    "LOGOUT": "Logge ut",
    "MY_ACCOUNT": "Min konto",
    "USER": "Bruker",
    "SHIPPING_ADDRESS": "Leveranseadresse",
    "WISHLIST": "Ønskeliste",
    "EMAIL": "E-mail",
    "BALANCE": "Saldo",
    "DATE": "Dato",
    "SEE_ALL": "Se alle",
    "EDIT": "Endre",
    "YOUR_BALANCE": "Din saldo er %amount",
  },
  "WISHLIST": {
    "TITLE": "Ønskeliste",
    "BACK": "Gå til min konto",
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Etternavn",
    "STREET_1": "Gateadresse 1",
    "STREET_2": " Gateadresse 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "OR": "eller",
  "VALUE": "Verdi",
  "CART": {
    "DISTRIBUTION": "Betalingsfordeling",
    "CLOSE": "Lukk handlekurven",
    "HEADING": "Handlekurv",
    "TOTALS": "Totalt",
    "YOUR_BALANCE": "Din saldo",
    "AFTER_PURCHASE": "Saldo etter kjøp",
    "VALID_TO": "Gyldig til",
    "PAY_CASH": "Kort/faktura",
    "PAY_VOUCHER": "Gavekort",
    "EMPTY": "Handlekurven er tom",
    "INCREMENT": "Øke antall",
    "DECREMENT": "Minsk antall",
    "QUANTITY": "Antall",
    "CTA": "Gå til handlekurven",
    "PRODUCTS": "Produkter",
    "SHIPPING": "Frakt",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå til kassen",
    "MOVE_TO_WISHLIST": "Flytt til ønskeliste",
    "DIALOG_CANCEL": "Avbryt",
    "REMOVE_PRODUCT": "Fjern produkt",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra handlekurven?",
    "CONTINUE_SHOPPING": "Fortsett handle",
    "DISCOUNT": "Rabatt",
    "SUB_TOTAL": "Beløp",
    "SUB_TOTAL_WITH_DISCOUNT": "Delsum eksklusive rabatt",
    "GRAND_TOTAL": "Totalt",
    "CLOSE_SUMMARY": "Lukk oversikten",
    "OPEN_SUMMARY": "Åpne oversikten",
  },
  "CHECKOUT": {
    "TITLE": "Kasse",
    "CART": "Din handlekurv inneholder ",
    "CONTINUE": "Fortsett",
    "CUSTOMER_INFORMATION": "Kundeinformasjon",
    "REDEEM_NOTICE": "Nå kan du gjennomføre bestillingen og dermed oppgi koden på dit Zupergift-gavekort. Din handlekurvs verdi kan ikke overskride saldoen på gavekortet.",
    "DELIVERY_NOTICE": "Når du godkjent og brukt din Zupergift sendes gavekortene du valgt til den e-post du oppgjett.",
    "CONTACT_CUSTOMER_SERVICE": "Kontakte kundeservice",
    "PLACE_ORDER": "Godkjenn og",
    "TO_PAYMENT": "Gå til betaling",
    "EMAIL": "E-postadresse",
    "EMAIL_REPEAT": "Gjenta e-postadresse",
    "TELEPHONE": "Mobilnummer",
    "AMOUNT_TO_PAY": "Å betale",
    "PAY_WITH_CARD": "Betale med kort",
    "EDIT": "Endre",
    "DELIVERY": "Leveranse",
    "SENT_TO": "Sendes till",
    "CONTINUE_SHOPPING": "Fortsett å handle",
    "BACK_TO_CART_TEXT": "Tilbake til handlekurven",
    "COMPLETE_PURCHASE": "Fullfør kjøp",
    "CARD_PAYMENT": "Kortbetaling",
    "REDEEM_LABEL_CODE": "Gavekortkode",
    "REDEEM_LABEL_PIN": "Oppgi tilhørende pinkoden",
    "REDEEM_SUBMIT": "Brukt",
    "REDEEM_AMOUNT": "Din Zupergift inneholder totalt %value.",
    "REDEEM_ERROR_INSUFFICIENT": "Du har %value på ditt Zupergift-gavekort. Nedenfor ser du varemerkes-gavekortene du lagt i handlekurven og hvor mye som gjennstår på Zupergift-gavekortet etter kjøpet.",
    "REDEEM_BUTTON_LABEL": "Jeg har en Zupergiftkode",
    "OPT_EMAIL": "Jeg ønsker informasjon om tilbud fra Zupergift",
    "I_ACCEPT_THE": "Jeg aksepterer",
    "TERMS": "kjøpsvilkårene",
    "TERMS_URL": "vilkar",
    "PAYMENT_METHOD_STEP": "Velg betalingsmetode",
    "PAY_STEP": "Gå til sikker betaling",
    "ADDRESS": {
      "ADDRESS": "Faktura og leveringsinformasjon",
      "SHIPPING": "Leveranseadresse",
      "BILLING": "Fakturaadresse",
      "SHIP_TO_SAME_ADDRESS": "Leveres til samme adresse",
      "CONTACT_INFO": "Kontaktinformasjon",
    },
    "DISCOUNT_CODE": {
      "HEADER": "Rabattkode",
      "PLACEHOLDER": "Skriv inn kode",
      "APPLY": "Anvend",
      "REMOVE": "Ta vekk",
    },
  },
  "PAYMENT": {
    "TITLE": "Hvordan vill du betale?",
    "USE_PAY": "Betale nå",
    "USE_CARD": "Betal med kort",
  },
  "PAYMENT_METHODS": {
    "APPLE_PAY": "pay",
    "ALTAPAY": {
      "CARD": "Betal med kort",
    },
  },
  "PAYMENT_LIMIT": {
    "TEXT_ONE": "Det er foreløpig ikke mulig å handle for mer enn %amount.",
    "TEXT_TWO": "Ta kontakt med kundeservice for mer informasjon på <a href=\"mailto:info@awardit.com\">info@awardit.com</a>.",
  },
  "SUCCESS": {
    "TITLE": "Bestillingen er registrert",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Fortsett å handle",
    "NOT_FOUND_TITLE": "Ingen ordre funnet.",
    "NOT_FOUND_SUBTITLE": "Ta kontakt med kundeservice hvis dette er feil.",
    "WHAT_NOW": "Så hva skjer nå?",
    "STEPS": {
      "HEADING": " Bestillingen er registrert ",
      "WHAT_NOW": " Så hva skjer nå?",
      "LABEL": "Din bestilling",
      "ORDER_ID": "Ordrenummer %id",
      "QUESTIONS": {
        "HEADING": "Har du et spørsmål om din bestilling?",
        "LABEL": "Gå til kundeservice",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "En ordrebekreftelse sendes til %email innen kort.",
        },
        "2": {
          "HEADING": "Bearbeider",
          "TEXT": "Din bestilling blir sendt når alle produktene er på lager. Dette skjer normalt nestkommende dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leveranse",
          "TEXT": "Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse och dina digitala biljetter/värdekoder kommer att skickas till %email inom kort. Har du inte fått någon e post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Din fysiska leverans skickas med DBSchenker. Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "Du får en ordrebekreftelse til %email.",
        },
        "2": {
          "HEADING": "Digital leveranse",
          "TEXT": "Vi sender dine digitale verdikoder %email innen kort. Har du ikke mottatt noen e-post ber vi deg dobbeltsjekke spamfiltret før du kontakter kundeservice.",
        },
      },
    },
    "CONTACT": {
      "HEADING": "Lurer du på noe?",
      "TEXT": "Vi svarer på dine spørsmål om leveranser og produkter 48 timer på hverdager.",
      "LINK": "https://helpdesk.crossroads.se/?s=160098dfe19afa160098dfe19b34",
      "LINK_TEXT": "Skriv til oss via kontaktskjemaet",
    },
  },
  "OLD_BROWSER": {
    "INFO": "Hei! Du bruker en utdatert nettleser. Vennligst <a href=\"http://outdatedbrowser.com\" rel=\"noopener\" target=\"blank\">oppdater din nettleser</a> for  å bruke zupergift.com",
  },
  "CATEGORY": {
    "EMPTY": "Det finns ingenting å vise akkurat nå",
    "LOAD_MORE": "Lade flere",
    "PRODUCTS_IN_CATEGORY_TITLE": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
  },
  "ALL_GIFTCARDS": {
    "TITLE": "Alle gavekort",
  },
  "404": {
    "TITLE": "Siden kunne ikke finnes",
    "HEADING": "— 404 —",
    "SUBHEADING": "Siden kunne ikke finnes",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfeil",
    "HEADING": "Serverfeil: 500",
    "SUBHEADING": "Vennligst kom tilbake innen kort!",
    "TEXT": "<strong>Vil du komme i kontakt med oss?</strong><br/> Send en mail til <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SLIDER": {
    "SLIDE": "Slide %number",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søk: ",
    "PLACEHOLDER": "Søk etter gavekort",
    "SEARCH_RESULT": "Fant 1 produkt som passet",
    "PRODUCTS_IN_SEARCH_RESULT": "Fant %itemsCount produkter som passet",
    "PRODUCT_IN_SEARCH_RESULT": "Fant én produkt som passet",
    "ICON": "Søkeikon",
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alle filter",
      "FILTER_BY_POINTS": "Filtrere på poeng",
      "FILTER_BY_PRICE": "Filtrere på pris",
      "PRICE_RANGE": "%min - %max kr",
      "SORT": "Sortera",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Navn ↓",
      "SORT_NAME_ASC": "Navn  ↑",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Se resultat",
      "CLOSE_MENU": "Lukk filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Fjern filter",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filter",
      "PRICE_RANGE": "Pris (%range)",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrere på poeng",
      "FILTER_BY_POINTS": "Filtrere på pris",
      "RESET_PRICE": "Rense filter",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
    },
  },
  "HEADER": {
    "OPEN_MENU": "Åpne menyen",
    "CLOSE_MENU": "Lukk menyen",
    "BACK": "Gå tilbake",
    "SEARCH": "Søk",
    "ALL_GIFTCARDS": "Alle gavekort",
    "BUY_ZUPERGIFT": "Kjøp Zupergift",
    "REDEEM_GIFTCARD": "Bruk Zupergift",
    "CATEGORIES": "Kategorier",
    "CART": "Handlekurv",
    "HELP": "Kontakt",
    "ABOUT": "Hvordan fungerer det?",
    "CLOSE_CATEGORIES": "Lukk kategorier",
    "BRANDS": "Varemerker",
    "CLOSE_BRANDS": "Lukk varemerker",
    "ACCOUNT": "Minvkonto",
    "CUSTOMER_SERVICE": "Kundeservice",
  },
  "FOOTER": {
    "CURRENT_LANG": "Du besöker vår norska Zupergift-butik.",
    "CHANGE_LANG": "Byt till vår svenska butik",
    "CHANGE_LANG_URL": "https://zupergift.com/se/",
    "CATEGORIES": "Kategorier",
    "COPYRIGHT": "Copyright © %currentYear",
    "RECAPTCHA": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\">Terms of Service</a> apply.",
    "LANGUAGE_SWITCHER_TEXT": "You're using the Norwegian version of Zupergift",
    "LANGUAGE_SWITCHER_BUTTON": "Change language/region",
    "COOKIES": "Administrer cookies",
    "TERMS_LINK": "vilkar",
    "TERMS_TEXT": "Kjøpsvilkår",
  },
  "LANGUAGE_SWITCHER": {
    "TITLE": "Welcome!",
    "CLOSE": "Close language switcher",
    "SUB_TITLE": "You're using the Norwegian version of Zupergift. Do you want to change language/region?",
    "FINLAND": "Finland",
    "DENMARK": "Denmark",
    "NORWAY": "Norway",
    "SWEDEN": "Sweden",
  },
  "BREADCRUMBS": {
    "HOME_URL": "/",
    "HOME": "Hjem",
    "SEARCH_RESULTS_FOR": "Søkeresultat for: ",
  },
  "PRODUCT": {
    "STARTING_AT": "Fra",
    "ADD_TO_CART": "Legg i handlekurv",
    "OUT_OF_STOCK": "Slut på lager",
    "TOO_LOW_BALANCE": "For lavt saldo",
    "DESCRIPTION": "Produktbeskrivelse",
    "OTHERS_ALSO_LIKED": "Andre likte også",
    "OPTION_PLACEHOLDER": "Velg %attributeLabel",
    "LOGIN_TO_PURCHASE": "Logg inn for å handle",
    "CHANGE_IMAGE": "Bytt bilde",
    "OPTION_DROPDOWN_PLACEHOLDER": "Velg et alternativ...",
  },
  "VALIDATION": {
    "REQUIRED": "Dette er obligatorisk.",
    "EMAIL": "Vennligst oppgi korrekt e postadresse.",
    "PHONE": " Vennligst oppgi korrekt mobiltelefonnummer.",
    "NUMERIC": "Feltet kan kun inneholde nummer.",
    "LENGTH_LT": "Feltet inneholder for mange tegn.",
    "POSTCODE": "Vennligst oppgi korrekt postnummer. (XXX XX)",
    "MATCH": "Informasjonen stemmer ikke overens.",
    "PHONE_LENGTH_COLLECTOR": "Mobilnummeret er for kort.",
    "MISSING_FIELD": "Mangler adresse. Prøv igjen",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "En ukjent feil har. Vennligst lad siden på nytt.",
    "NETWORK_ERROR": "Anropet ble avbrutt. Vennligst verifiser at du har en aktiv internettoppkobling.",
    "PLACE_ORDER_CATCH": "En feil oppsto, vennligst prøv igjen Vennligst prøv igjen.",
    "AQUIRER_DECLINE": "Betalingen har blitt avvist. Vennligst bekreft kort-/kontoopplysningene dine.",

    "COLLECTOR": {
      "SESSION_EXPIRED": "Sessionen med Collector har opphørt, vennligst last siden på nytt.",
      "NUM_TRIES_EXCEEDED": "Kunne ikke hente bestillingen. Vennligst ta kontakt med kundeservice.",
    },

    "errorProductQuantityNotAvailable": "Det antallet du oppgav er ikke tilgjengelig akkurat nå.",
    "errorProductNotInStock": "Produktet du prøvde å legge i handlekurven er dessverre ikke på lager akkurat nå.",
    "errorProductMaxQuantity": "Det ønskede antallet er dessverre ikke på lager akkurat nå.",
    "errorProductNotChosenVariant": "Vennligst velg %attributeLabel for å legge produktet i handlekurven.",
    "termsNotAccepted": "Du må godjenne handlebetingelsene for å gjennomføre kjøpet.",
    "errorBillingAddressValidationFailed": "Feil adresse",
    "REDEEM_ERROR": {
      "_777": "Gavekortskoden er ikke gyldig. Kontroller koden og prøv igjen.",
      "_786": "Ukjent feil, kontroller koden og prøv igjen.",
      "_791": "Gavekortskoden krever pinkode. Vennligst oppgi tilhørende pinkode og prøv igjen.",
      "_792": "Pinkoden er ikke gyldig. Kontrollere pinkoden og prøv igjen.",
    },
    "success": "Gavekortskoden er aktivert!",
    "DISCOUNT_CODE_FAILURE": "Rabattkoden kunne ikke brukes, prøv igjen eller kontakt kundeservice.",
    "DISCOUNT_CODE_APPLIED": "Rabattkode brukt.",
  },
};
